import Script from 'next/script';

import { useConsentManager } from './consent-manager';

/**
 * Load the StackAdapt events script after airgap.js is initialized
 */
export const StackAdaptScript: React.FC = () => {
  const { airgap } = useConsentManager();

  return (
    <>
      {airgap && (
        <Script
          id="stackadapt-events"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `
              !function(s,a,e,v,n,t,z){if(s.saq)return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');saq('ts', 'blfGeega_oOj3AxQihucOQ');
            `,
          }}
        />
      )}
    </>
  );
};
